import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { Layout, PageHeader } from "../../common/components";
import { HomePage } from "./page";
import { hasRights, rights } from "../../common/utils/role-right-helper";

const HomeHeader = (
  <PageHeader title="Dashboard" />
)

const Home = () => {
  if (!hasRights([rights.CanViewHub]))
    return <Redirect to="/search" />

  return (
    <Layout PageHeader={HomeHeader}>
      <Switch>
        <Route exact path="/" component={HomePage} />
      </Switch>
    </Layout>
  );
};

Home.propTypes = {
  match: PropTypes.shape({}),
};

Home.defaultProps = {
  match: {},
};

export default withRouter(Home);
